import _isFunction from "lodash/isFunction";
import _isObject from "lodash/isObject";
import _isString from "lodash/isString";

function compareStrings(str1, str2) {
    return str1.localeCompare(str2);
}

function compareOther(val1, val2) {
    if (val1 > val2) {
        return 1;
    }
    if (val1 < val2) {
        return -1;
    }
    return 0;
}

export function propertyComparator(property) {
    return function(obj1, obj2) {
        const val1 = obj1[property];
        const val2 = obj2[property];
        if (_isString(val1) && _isString(val2)) {
            return compareStrings(val1, val2);
        } else {
            return compareOther(val1, val2);
        }
    };
}

function reversedComparator(comparator) {
    return (obj1, obj2) => -1 * comparator(obj1, obj2);
}

/**
 *
 * comparator: string | function
 *   If string, will use default compare on the object property
 *   Function is a sort function in the format (a,b)=>number
 * reversed: boolean
 *   Reverses the order of the sort
 * @returns {Function}
 * @param comparators
 */
export function composeComparators(comparators) {
    /*
     * save the arguments object as it will be overwritten
     * note that arguments object is an array-like object
     * consisting of the names of the properties to sort by
     */
    const compareFunctions = comparators.map(comparator => {
        if (!_isObject(comparator)) {
            throw new Error(
                "Sort error: expected arguments to be objects with fields named 'comparator' and 'reversed'. Got " +
                    JSON.stringify(comparator)
            );
        }

        let compareFunction = comparator.comparator;
        if (_isString(compareFunction)) {
            compareFunction = propertyComparator(compareFunction);
        }
        if (!_isFunction(compareFunction)) {
            throw new Error(
                "Sort error: comparator must be a string or function. Got " +
                    JSON.stringify(compareFunction)
            );
        }

        return comparator.reversed
            ? reversedComparator(compareFunction)
            : compareFunction;
    });

    return function(obj1, obj2) {
        for (let compare of compareFunctions) {
            const result = compare(obj1, obj2);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
}



// WEBPACK FOOTER //
// ./src/helpers/array.js